/* Keep OCU percentage-off tiles consistent with the app's verified cent-truncated discount allocations. */
(() => {
  const update = () => {
    document.querySelectorAll('.ocu-cart-drawer .ocu-product-card__container').forEach(card => {
      const original = card.querySelector('[data-testid="was-price-editor"]');
      const discounted = card.querySelector('[data-testid="now-price-editor"]');
      const savings = card.querySelector('[data-testid="savings-amount-editor"]');
      const price = original?.textContent.trim().match(/^\$([\d,]+\.\d{2})$/);
      const offered = discounted?.textContent.trim().match(/^\$([\d,]+\.\d{2})$/);
      const percent = savings?.textContent.trim().match(/^(\d+(?:\.\d+)?)%$/);
      if (!price || !offered || !percent) return;
      const cents = Math.round(Number(price[1].replaceAll(',', '')) * 100);
      const rate = Number(percent[1]);
      if (!(rate > 0 && rate < 100)) return;
      const charged = cents - Math.floor(cents * rate / 100 + 1e-8);
      const shown = Math.round(Number(offered[1].replaceAll(',', '')) * 100);
      // Only resolve the observed one-cent rounding disagreement, preserving all app pricing and cart behavior.
      if (charged - shown !== 1) return;
      const text = '$' + (charged / 100).toLocaleString('en-US', {minimumFractionDigits:2,maximumFractionDigits:2});
      const walker = document.createTreeWalker(discounted, NodeFilter.SHOW_TEXT);
      for (let node; (node = walker.nextNode());) {
        if (node.nodeValue.includes(offered[0])) { node.nodeValue = node.nodeValue.replace(offered[0], text); break; }
      }
    });
  };
  const start = () => {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    }).observe(document.body, {subtree:true,childList:true,characterData:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
